import { useState, useEffect, useRef } from 'react';

import { Col, OverlayTrigger, Row } from 'react-bootstrap';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import {
  useGetSingleFloristProductDrawerQuery,
  useGetSingleProductQuery,
} from '../../features/products/productsApiSlice';

import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import styled from 'styled-components';
import StyledText from '../../app/components/styledComponents/StyledText';
import { StyledCustomButton } from '../../app/components/styledComponents/StyledCustomButton';
import StyledButton from '../../app/components/styledComponents/StyledButton';
import FullScreenIcon from './assets/full-screen.svg';
import { calculateServiceFee, getColor } from '../../utils/helper';
import Slider from 'react-slick';
import StyledLoading from '../../app/components/loading/StyledLoading';
import useAuth from '../../hooks/useAuth';
import { StyledTooltip } from '../../app/components/styledComponents/StyledTooltip';
import { productDefaultImage } from './assets/productsUtil';
import { HolidayPriceTag } from './ProductCard';
import { formatNumber } from '../../utils/helper';
import { useSelector } from 'react-redux';

SwiperCore.use([Navigation, Pagination, Autoplay]);

const calculatePrice = (product, variations, isCatalogue, isSelectProduct) => {
  const price = variations?.length
    ? variations?.find((item) => item.defaultVariation)?.price?.toFixed(2) ??
      variations[0].price.toFixed(2)
    : product.price?.toFixed(2) ?? '';

  const oldPrice = variations?.length
    ? variations
        ?.find((item) => item.defaultVariation)
        ?.discountedPrice?.toFixed(2) ?? ''
    : product.oldPrice?.toFixed(2) ?? '';

  const isDiscountApplied = variations?.length
    ? variations?.find((item) => item.defaultVariation)?.discountPriceApplied
    : product.discountPriceApplied;

  const isHolidayPriceApplied = variations?.length
    ? variations?.find((item) => item.defaultVariation)?.holidayPriceApplied
    : product.holidayPriceApplied;

  const originalPrice = variations?.length
    ? variations.find((item) => item.defaultVariation)?.originalPrice ??
      variations[0].originalPrice
    : product.originalPrice ?? '';

  const discountPrice = variations?.length
    ? variations?.find((item) => item.defaultVariation)?.discountPrice
    : product?.discountPrice;

    const holidayPrice = variations?.length
    ? variations?.find((item) => item.defaultVariation)?.holidayPrice
    : product?.holidayPrice;

  if(!isCatalogue){
    return (
       <div className="d-flex flex-column">
              {(isDiscountApplied || isHolidayPriceApplied) && originalPrice ? (
                <div>
                  {isHolidayPriceApplied && holidayPrice ? (
                    <div className="d-flex flex-column">
                      <div className="d-flex flex-row align-items-center gap-2">
                        <Price>${formatNumber(holidayPrice)}</Price>
                        <OffPrice>${formatNumber(originalPrice)}</OffPrice>
                      </div>
                      <StyledText
                        color={'bodyMedium'}
                        $fontSize={'12px'}
                        $fontWeight={500}
                        className={`mb-0 margin-right`}
                      >
                        DP :
                        {discountPrice
                          ? ` $${formatNumber(discountPrice)}`
                          : oldPrice
                          ? ` $${formatNumber(oldPrice)}`
                          : ' NA'}
                      </StyledText>
                    </div>
                  ) : isDiscountApplied && discountPrice ? (
                    <div className="d-flex flex-column">
                      <div className="d-flex flex-row align-items-center gap-2">
                        <Price>${formatNumber(discountPrice)}</Price>
                        <OffPrice>${formatNumber(originalPrice)}</OffPrice>
                      </div>
                      <StyledText
                        color={'bodyMedium'}
                        $fontSize={'12px'}
                        $fontWeight={500}
                        className={`mb-0 margin-right`}
                      >
                        HP :{holidayPrice ? ` $${formatNumber(holidayPrice)}` : ' NA'}
                      </StyledText>
                    </div>
                  ) : (
                    <div className="d-flex flex-column">
                      <Price>${formatNumber(price)}</Price>
                      <div className="d-flex align-items-center gap-2">
                        <StyledText
                          color={'bodyMedium'}
                          $fontSize={'12px'}
                          $fontWeight={500}
                          className={`mb-0 margin-right`}
                        >
                          HP :
                          {holidayPrice ? ` $${formatNumber(holidayPrice)}` : ' NA'}
                        </StyledText>
                        <StyledText
                          color={'bodyMedium'}
                          $fontSize={'12px'}
                          $fontWeight={500}
                          className={`mb-0 margin-right`}
                        >
                          DP :{oldPrice ? ` $${formatNumber(oldPrice)}` : ' NA'}
                        </StyledText>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <Price>${formatNumber(price)}</Price>
                  </div>
      
                  <div className="d-flex align-items-center gap-2">
                    <StyledText
                      color={'bodyMedium'}
                      $fontSize={'12px'}
                      $fontWeight={500}
                      className={`mb-0 margin-right`}
                    >
                      HP :{holidayPrice ? ` $${formatNumber(holidayPrice)}` : ' NA'}
                    </StyledText>
                    <StyledText
                      color={'bodyMedium'}
                      $fontSize={'12px'}
                      $fontWeight={500}
                      className={`mb-0 margin-right`}
                    >
                      DP :{oldPrice ? ` $${formatNumber(oldPrice)}` : ' NA'}
                    </StyledText>
                  </div>
                </div>
              )}
      
              <StyledText
                color={'bodyLight'}
                $fontSize={'12px'}
                className={`mb-0 margin-right`}
              >
                <OverlayTrigger
                  overlay={
                    <StyledTooltip>
                      <span
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        A service fee of $5.99 or 4%, whichever is higher, is applied
                        to each order. Florists can choose to pay this fee from the
                        received amount, or to apply it to the customer during
                        checkout (this means the customer pays it). This fee covers
                        the credit card processing and servicing of the order.
                      </span>
                    </StyledTooltip>
                  }
                >
                  <span style={{ cursor: 'pointer' }}>
                    (services fee: ${calculateServiceFee(oldPrice)})
                  </span>
                </OverlayTrigger>
              </StyledText>
            </div>
    )
  }

  return (
    <>
      {!isCatalogue && (oldPrice || discountPrice) ? (
        <div>
          {' '}
          <div className="d-flex align-items-center gap-2">
            <Price>
              $
              {isDiscountApplied
                ? formatNumber(discountPrice)
                : formatNumber(oldPrice)}
            </Price>
            <OffPrice>
              $
              {isDiscountApplied || isHolidayPriceApplied
                ? formatNumber(originalPrice)
                : formatNumber(price)}
            </OffPrice>
          </div>
          {isCatalogue && isSelectProduct ? (
            <StyledText
              color={'primary'}
              fontSize={'18px'}
              className={`mb-0 margin-right mt-2`}
            >
              (Suggested Price)
            </StyledText>
          ) : (
            !(isCatalogue && !isSelectProduct) && (
              <>
                {holidayPrice && (
                  <StyledText
                    color={'bodyLight'}
                    $fontSize={'11px'}
                    className={`mb-0 margin-right`}
                  >
                    (Holiday Price : ${formatNumber(holidayPrice)})
                  </StyledText>
                )}
                <StyledText
                  color={'bodyLight'}
                  style={{
                    width: 'max-content',

                    cursor: 'pointer',
                  }}
                  $fontSize={'12px'}
                  className={`mb-0 margin-right`}
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <StyledTooltip>
                        <span
                          style={{
                            fontSize: '12px',
                          }}
                        >
                          A service fee of $5.99 or 4%, whichever is higher, is
                          applied to each order. Florists can choose to pay this
                          fee from the received amount, or to apply it to the
                          customer during checkout (this means the customer pays
                          it). This fee covers the credit card processing and
                          servicing of the order.
                        </span>
                      </StyledTooltip>
                    }
                  >
                    <span>
                      (services fee: ${calculateServiceFee(oldPrice)})
                    </span>
                  </OverlayTrigger>
                </StyledText>
              </>
            )
          )}
        </div>
      ) : (
        <div>
          {isHolidayPriceApplied ? (
            <Price>${formatNumber(originalPrice)}</Price>
          ) : (
            <Price>${price}</Price>
          )}
          {isCatalogue && isSelectProduct ? (
            <StyledText
              color={'primary'}
              fontSize={'18px'}
              className={`mb-0 margin-right`}
            >
              (Suggested Price)
            </StyledText>
          ) : (
            !(isCatalogue && !isSelectProduct) && (
              <>
                {holidayPrice && (
                  <StyledText
                    color={'bodyLight'}
                    $fontSize={'11px'}
                    className={`mb-0 margin-right`}
                  >
                    (Holiday Price : ${formatNumber(holidayPrice)})
                  </StyledText>
                )}
                <StyledText
                  color={'bodyLight'}
                  style={{
                    width: 'max-content',
                    cursor: 'pointer',
                  }}
                  $fontSize={'12px'}
                  className={`mb-0 margin-right`}
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <StyledTooltip>
                        <span
                          style={{
                            fontSize: '12px',
                          }}
                        >
                          A service fee of $5.99 or 4%, whichever is higher, is
                          applied to each order. Florists can choose to pay this
                          fee from the received amount, or to apply it to the
                          customer during checkout (this means the customer pays
                          it). This fee covers the credit card processing and
                          servicing of the order.
                        </span>
                      </StyledTooltip>
                    }
                  >
                    <span>(services fee: ${calculateServiceFee(price)})</span>
                  </OverlayTrigger>
                </StyledText>
              </>
            )
          )}
        </div>
      )}
    </>
  );
};

const VariationsButton = styled(StyledButton)`
  color: ${({ color, theme, variant, active }) =>
    variant === 'outline'
      ? active
        ? theme.white
        : getColor(color, theme)
      : theme.white};
  background-color: ${({ color, theme, variant, active }) =>
    variant !== 'outline'
      ? getColor(color, theme)
      : active
      ? getColor(color, theme)
      : 'transparent'};
  font-size: ${({ $fontSize }) => $fontSize ?? 'inherit'};
  font-weight: ${({ $fontWeight }) => $fontWeight ?? 'inherit'};
`;

const StyleLoaderWrapper = styled.div`
  position: relative;
  > div {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: -10px;
    background: #fff;
    z-index: 999999999999999;
    display: flex;
    align-items: baseline;
  }
`;

const StyleSliderHolder = styled.div`
  position: relative;

  .slideNext-btn.custom_next_f,
  .slidePrev-btn.custom_prev_f {
    position: absolute;
    right: -10px;
    z-index: 999;
    font-size: 12px;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: calc(50% - 25px);
    transform: translateY(-50%);
    color: ${({ color, theme, variant, active }) =>
      variant === 'outline'
        ? active
          ? theme.white
          : getColor(color, theme)
        : theme.white};
    background-color: ${({ color, theme, variant, active }) =>
      variant !== 'outline'
        ? getColor(color, theme)
        : active
        ? getColor(color, theme)
        : 'transparent'};
  }
  .slidePrev-btn.custom_prev_f {
    right: unset;
    left: -10px;
  }

  .slick-slide > div > div > img {
    border: 2px solid transparent;
  }

  .slick-slide > div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .slick-slide {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .slick-current > div > div > img {
    border: 4px solid
      ${({ highlightActive, theme }) =>
        highlightActive ? theme.primary : 'transparent'};
    border-radius: 3px;
  }
`;

const StyleSliderImage = styled.div`
  height: 200px;
  position: relative;
  background: rgb(231 231 231 / 39%);

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center center;
  }
`;

const StyleSliderImageThumb = styled.div`
  height: 100%;
  background: rgb(231 231 231 / 39%);
  width: 100% !important;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
`;

function CustomNextArrow(props) {
  const { onClick } = props;
  return (
    <div className="slidePrev-btn custom_prev_f" onClick={onClick}>
      <i className="fa fa-angle-left"></i>
    </div>
  );
}

function CustomPrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="slideNext-btn custom_next_f" onClick={onClick}>
      <i className="fa fa-angle-right"></i>
    </div>
  );
}

const ProductDetail = ({
  productId,
  isCatalogue,
  isSelectProduct,
  addToProductsHandler,
}) => {
    const { theme, previewTheme } = useSelector((state) => state.theme);
  const [updated, setUpdated] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [product, setProduct] = useState({});
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [productImages, setProductImages] = useState();
  const [productRecipe, setProductRecipe] = useState(null);
  const [productTags, setProductTags] = useState([]);
  const [variations, setVariations] = useState([]);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const { user } = useAuth();
  const getFloaristProductbyId = !isCatalogue
    ? useGetSingleFloristProductDrawerQuery
    : useGetSingleProductQuery;

  const {
    data: singleProduct,
    isLoading: isProductLoading,
    isFetching: isFetchingProduct,
    refetch,
  } = getFloaristProductbyId(productId, { skip: !productId });
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);
  const VariationDTOKey = isCatalogue
    ? 'variationDTOS'
    : 'floristVariationDTOS';

  useEffect(() => {
    setNav1(sliderRef1.current);
    setNav2(sliderRef2.current);
  }, []);

  useEffect(() => {
    setIsLoading(isProductLoading && isFetchingProduct);
    if (singleProduct?.objectData) {
      const products = singleProduct?.objectData;
      setProduct(products);
      setProductTags(
        products?.inventoryTagDTOS || products?.floristInventoryTagDTOS,
      );
    }
  }, [singleProduct, isProductLoading, isFetchingProduct]);

  useEffect(() => {
    if (productId) {
      refetch();
    }
  }, [productId, refetch]);

  useEffect(() => {
    if (productImages) {
      setUpdated([...productImages]);
    }
  }, [productImages]);

  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: '#my-test-gallery',
      children: 'a',
      counterTitle: 'sdfhkj',
      pswpModule: () => import('photoswipe'),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);

  const replaceOembedWithIframe = (htmlString) => {
    return htmlString.replace(
      /<oembed url="([^"]+)"><\/oembed>/g,
      (match, url) => {
        if (url.includes('youtube.com')) {
          return `<iframe width="460" height="315" src="${url}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        }
        return match;
      },
    );
  };

  useEffect(() => {
    setVariations(product?.[VariationDTOKey] ?? []);
  }, [product]);

  useEffect(() => {
    if (variations?.find((p) => p?.defaultVariation)?.imageDTOList?.length) {
      setProductImages(
        variations?.find((p) => p?.defaultVariation)?.imageDTOList,
      );
    } else {
      if (
        !product?.floristInventoryImages?.length &&
        !product?.inventoryImages?.length
      ) {
        setProductImages([
          {
            thumbnailUrl: productDefaultImage,
            url: productDefaultImage,
          },
        ]);
      } else {
        setProductImages(
          product?.inventoryImages || product?.floristInventoryImages,
        );
      }
    }

    if (variations?.find((p) => p?.defaultVariation)?.recipe) {
      setProductRecipe(variations?.find((p) => p?.defaultVariation)?.recipe);
    } else {
      setProductRecipe(product?.recipe);
    }
  }, [variations]);

  const StyledCol = styled(Col)`
    border: ${({ theme , price }) =>
      !isCatalogue && price && ((product?.holidayPriceApplied && product?.holidayPrice) || (product?.discountPriceApplied && product?.discountPrice))
        ? `2px solid ${theme.primary}`
        : 'none'};
    padding: 10px 0px 0px 0px;
    border-radius: 0px 0px 8px 8px;
  `;

  return (
    <>
      {isLoading && (
        <StyleLoaderWrapper>
          <StyledLoading />
        </StyleLoaderWrapper>
      )}
      <DetailDiv>
        <Row>
          <Col lg={5} md={12} className="mb-3 mb-md-0">
            <Row>
              <StyledCol
                price={
                  variations && variations?.length > 0
                    ? variations?.find((item) => item.defaultVariation)
                        ?.holidayPrice ||
                      variations?.find((item) => item.defaultVariation)
                        ?.discountPrice
                    : product?.holidayPrice || product?.discountPrice
                }
                lg={12}
                md={12}
              >
                <div className="pswp-gallery" id={'my-test-gallery'}>
                  {updated?.map((val, index) => (
                    <a
                      href={val.url}
                      data-pswp-width={1500}
                      data-pswp-height={1266}
                      key={`my-test-gallery-${index + 1}`}
                      rel="noreferrer"
                      idnex={1}
                      target="_blank"
                    >
                      <div className="full-screen">
                        <img
                          loading="lazy"
                          src={FullScreenIcon}
                          alt=""
                          id="full-screen-icon"
                          height={32}
                          width={32}
                          onClick={() => setIsFullScreen(!isFullScreen)}
                        />
                      </div>
                    </a>
                  ))}
                </div>

                <StyleSliderHolder>
                  <Slider
                    dots={true}
                    asNavFor={nav2}
                    ref={(slider) => (sliderRef1 = slider)}
                    centerMode={true}
                    customPaging={(index) => (
                      <StyleSliderImageThumb>
                        <img
                          loading="lazy"
                          src={
                            productImages[index]?.thumbnailUrl ||
                            productImages[index]?.url
                          }
                          alt=""
                        />
                      </StyleSliderImageThumb>
                    )}
                  >
                    {productImages?.map((val, index) => (
                      <StyleSliderImage key={index}>
                        <img loading="lazy" src={val.url} alt="" />
                      </StyleSliderImage>
                    ))}
                  </Slider>
                </StyleSliderHolder>
                <style>
                  {`
                    .slick-slider .slick-dots {
                    position : absolute !important;
                    top : 285px !important
                    }
                    .slick-dots li {
                    height : 56px;
                    width : 56px;
                    }

                    .slick-dots .slick-active {
                    border : 4px solid ${theme.primary} !important;
                    }
                    `}
                </style>

                {!isCatalogue && (
                  <>
                    {product?.holidayPriceApplied &&
                    (variations && variations.length > 0
                      ? variations?.find((item) => item.defaultVariation)
                          ?.holidayPrice
                      : product?.holidayPrice) ? (
                      <HolidayPriceTag
                        style={{ width: '100%' }}
                        className="w-100"
                      >
                        Holiday Price Applied :{' '}
                        {variations?.length
                          ? formatNumber(
                              variations?.find((item) => item.defaultVariation)
                                ?.holidayPrice,
                            ) ?? formatNumber(variations[0]?.holidayPrice)
                          : formatNumber(product?.holidayPrice) ?? '-'}
                      </HolidayPriceTag>
                    ) : product?.discountPriceApplied &&
                      (variations && variations.length > 0
                        ? variations?.find((item) => item.defaultVariation)
                            ?.discountPrice
                        : product?.discountPrice) ? (
                      <HolidayPriceTag
                        style={{ width: '100%' }}
                        className="w-100"
                      >
                        Discounted Price Applied :{' '}
                        {variations?.length
                          ? formatNumber(
                              variations?.find((item) => item.defaultVariation)
                                ?.discountPrice,
                            ) ?? formatNumber(variations[0]?.discountPrice)
                          : formatNumber(product?.discountPrice) ?? '-'}
                      </HolidayPriceTag>
                    ) : null}
                  </>
                )}
              </StyledCol>
            </Row>
          </Col>

          <Col lg={7} md={12}>
            <div className="detail-part text-center text-md-start">
              <ProductTitle className="card-title" style={{ maxWidth: '100%' }}>
                {product?.itemName}
              </ProductTitle>

              {product?.catalogItem &&
                (product?.productRecognition ? (
                  <p
                    style={{
                      fontStyle: 'italic',
                      fontSize: '14px',
                      color: '#9E9C9C',
                    }}
                  >
                    Designed by {product?.productRecognition || ''}
                  </p>
                ) : (
                  <p
                    style={{
                      fontStyle: 'italic',
                      fontSize: '14px',
                      color: '#9E9C9C',
                    }}
                  >
                    Designed by BoostFloral
                  </p>
                ))}
              <div className="d-flex gap-2 align-items-center">
                {calculatePrice(
                  product,
                  variations,
                  isCatalogue,
                  isSelectProduct,
                )}
              </div>
              <div className="options-wrapper mt-3">
                <h5>Tags:</h5>
                <p>
                  {productTags?.map((tag, index) => (
                    <span key={index}>
                      {index === 0 ? tag.name : `, ${tag.name}`}
                    </span>
                  ))}
                </p>
              </div>

              {product?.notes && (
                <div className="options-wrapper mt-3">
                  <h5>Note : </h5>
                  <p>{product?.notes ?? '-'}</p>
                </div>
              )}

              {variations?.length > 0 && (
                <div className="options-wrapper mt-3">
                  <h5>Variations:</h5>
                  <div className="d-flex gap-1">
                    {variations?.map((item, index) => {
                      const hasActive = variations.some(
                        (i) => i.defaultVariation,
                      );

                      // Determine if the current button should be active
                      const isActive =
                        item.defaultVariation || (!hasActive && index === 0);
                      return (
                        <div className="d-flex text-nowrap" key={index}>
                          <VariationsButton
                            active={isActive}
                            variant="outline"
                            className="py-1"
                            $fontSize="16px"
                            $fontWeight="500"
                            onClick={() => {
                              setVariations((prev) => {
                                return prev.map((i, idx) =>
                                  idx === index
                                    ? { ...i, defaultVariation: true }
                                    : { ...i, defaultVariation: false },
                                );
                              });
                            }}
                          >
                            {item.title}
                          </VariationsButton>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              <div className="options-wrapper mt-3">
                <h5>Description:</h5>
                <div
                  dangerouslySetInnerHTML={{
                    __html: product?.description,
                  }}
                />
              </div>

              {productRecipe && (
                <div className="options-wrapper mt-3">
                  <h5>Recipe:</h5>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: replaceOembedWithIframe(productRecipe),
                    }}
                  />
                </div>
              )}

              {isCatalogue &&
                !product?.catalogItem &&
                isSelectProduct &&
                user?.floristId !== product?.contributedFloristId && (
                  <StyledCustomButton.BtnDefault
                    className="fw-normal mt-3"
                    size="small"
                    borderRadius="4px"
                    onClick={() => addToProductsHandler()}
                  >
                    Add to products
                  </StyledCustomButton.BtnDefault>
                )}
            </div>
          </Col>
        </Row>
      </DetailDiv>
    </>
  );
};

const DetailDiv = styled.div`
  .full-screen {
    position: relative;
  }
  #full-screen-icon {
    top: 18px;
    position: absolute;
    z-index: 9;
    right: 18px;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 14px;
    display: inline-block;
    background-color: #959fa1;
    object-fit: contain;
  }
  .mySwiper3 {
    .swiper-slide {
      img {
        width: 100%;
        object-fit: cover;
      }
    }
    .swiper-button-next {
      &:after {
        background: #959fa1;
        padding: 6px 12px;
      }
    }
    .swiper-button-prev {
      &:after {
        background: #959fa1;
        padding: 6px 12px;
      }
    }
  }
  .slider-banner {
    &.slider-product {
      .slider-wrapper {
        .slider-btn {
          position: absolute;
          top: 26px;
          width: 100%;
          .slideNext-btn.custom_next_f {
            font-size: 24px;
            cursor: pointer;
            right: 0;
            position: absolute;
          }
          .slidePrev-btn.custom_prev_f {
            font-size: 24px;
            cursor: pointer;
            left: 0;
            position: absolute;
          }
          @media (max-width: 767px) {
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .all-product-swiper {
          margin: 20px 60px;
        }
      }
    }
  }
`;

const Price = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 27px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: -0.20000000298023224px;
  color: ${({ theme }) => theme.primary};
`;

const OffPrice = styled.div`
  text-decoration: line-through;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 18px;
  font-weight: 500;
  line-height: 29px;
  letter-spacing: -0.20000000298023224px;
  text-align: center;
  color: ${({ theme }) => theme.bodyLight};
`;

const ProductTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: ${({ theme }) => theme.heading};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  a {
    color: inherit !important;
  }
`;

export default ProductDetail;
